/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-animation-animate-rotate',
  templateUrl: './theme-option-animation-animate-rotate.component.html',
  styleUrls: ['./theme-option-animation-animate-rotate.component.css']
})
export class ThemeOptionAnimationAnimateRotateComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'animation_animateRotate';

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption(this.optionType, value, this.themeOptions.limitedTo(this.optionType));
  }

}
